<template src="./Edit.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store
            .dispatch("users/getForEdit", this.itemId)
            .then((res) => {
                this.vm = res;
                this.getFeatures();
            }).catch(() => { });
    },
    computed: {
        features() {
            return this.$store.state.users.features;
        },

    },
    data() {
        return {
            vm: {
                userTypeId: null,
                userType: null,
                loginName: null,
                permissions: [],
            },

        };
    },
    methods: {
        getFeatures() {
            this.$store.dispatch("users/getFeatures", this.vm.userTypeId);
        },

        confirm() {
            let vm = {
                loginName:this.vm.loginName,
                apikey:this.vm.apikey,
                secretApi:this.vm.secretApi,
                permissions:this.vm.permissions,
         
            }
            this.$store
                .dispatch("users/edit", { id: this.itemId, payload: vm })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },
        CheckAll(feature) {
            feature.permissions.forEach((permission) => {
                if (feature.checkAll) {
                    if (!this.vm.permissions.includes(permission.permissionId)) {
                        this.vm.permissions.unshift(permission.permissionId);
                    }
                } else {
                    if (this.vm.permissions.includes(permission.permissionId)) {
                        let index = this.vm.permissions.indexOf(permission.permissionId);
                        this.vm.permissions.splice(index, 1);
                    }
                }
            });
        },

        HandleChange(feature) {
            feature.checkAll = true;
            feature.permissions.forEach((permission) => {
                if (!this.vm.permissions.includes(permission.permissionId)) {
                    feature.checkAll = false;
                }
            });
        },
        back() {

            this.$emit("back");
        },
    },
};
</script>